import React from "react";
import image from "./success.svg";

export default ({ title, text, footer, showIcon, subtext }) => (
  <div className="pv6 bg-near-white">
    {showIcon && (
      <img src={image} alt="" className="mb2 ml-auto mr-auto db w4" />
    )}
    <h1 className="f3 f2-m f1-l fw2 black-90 mv3 tc relative center top-25 pl5 pr5">
      {title}
    </h1>
    <h2 className="f5 f4-m f3-l fw2 black-50 mt0 lh-copy tc relative center top-25 pl3 pr3 pl6-ns pr6-ns">
      {text}
    </h2>
    {subtext && (
      <h3 className="f5 f4-m f3-l fw2 black-50 mt0 lh-copy tc relative center top-25 pl3 pr3 pl6-ns pr6-ns">
        {subtext}
      </h3>
    )}
    {footer && <div className="mt2">{footer}</div>}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Message/index.js